import { combineReducers } from "redux";
import blogReducer from "./blogs/blogReducer";
import searchReducer from "./search_bar/reducer";

const rootReducer = combineReducers({
  blog: blogReducer,
  search: searchReducer,
});

export default rootReducer;
